module.exports = __webpack_public_path__ + "img/6.a9a4a170.png";